module.exports = __webpack_public_path__ + "static/media/ace4.50528730.png";